export default __webpack_public_path__ + "static/media/dot.cc69f65a.svg";